import { useEffect, useRef } from 'react'

import { DevToolDataUpdater } from '../provider/types'
import { initializeNetworkInterceptor } from '../utils/networkInterceptor'
import { requestTracker } from '../utils/requestTracker'

export function useProcessorMonitor(
  updateData: DevToolDataUpdater,
  isEnabled: boolean
): void {
  const cleanupRef = useRef<(() => void) | null>(null)

  useEffect(() => {
    if (!isEnabled) {
      // Cleanup interceptor if disabled
      if (cleanupRef.current) {
        cleanupRef.current()
        cleanupRef.current = null
      }
      return () => {}
    }

    // Initialize network interceptor
    cleanupRef.current = initializeNetworkInterceptor()

    // Subscribe to request tracker updates
    const unsubscribe = requestTracker.subscribe(() => {
      const requests = requestTracker.getRequests()
      updateData({
        type: 'PROCESSOR',
        payload: requests,
      })
    })

    // Initial update with current requests
    const requests = requestTracker.getRequests()
    updateData({
      type: 'PROCESSOR',
      payload: requests,
    })

    // Cleanup on unmount or when disabled
    return () => {
      unsubscribe()
      if (cleanupRef.current) {
        cleanupRef.current()
        cleanupRef.current = null
      }
    }
  }, [updateData, isEnabled])
}
